module.exports = __webpack_public_path__ + "static/media/menu-mobile.1376afba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu-mobile.svg
// module id = 154
// module chunks = 0